<template>
    <van-grid :column-num="3">
        <van-grid-item :icon="cust" text="客户管理" to="/hairheadstaff" />
        <van-grid-item :icon="send" text="客户分配" to="/sendhaircard" />
        <van-grid-item :icon="lamp" text="亮灯情况" to="/hairlamp" />
        <van-grid-item :icon="perf" text="门店业绩" to="/newmanager" />
        <van-grid-item :icon="hairdata" text="美发数据" to="/hairdata" />
        <van-grid-item :icon="hairjx" text="美发绩效" to="/hairjx" />
        <van-grid-item :icon="staffjx" text="员工绩效" to="/staffjx" />
        <van-grid-item :icon="hairstorereport" text="门店成绩单" to="/hairstorereport" />
        <van-grid-item :icon="ldmanager" text="领导管理" to="/hairleadermanager" />
        <van-grid-item :icon="douyin" text="抖音成交率" to="/hairdouyincjlv"/>
        <van-grid-item :icon="work" text="美发作品审核" to="/hairworkexamine" v-show="workshow"/>
    </van-grid>
</template>
<script>
    export default {
        data() {
            return {
                cust:require('../../assets/cust.png'),
                lamp:require('../../assets/lamp.png'),
                send:require('../../assets/send.png'),
                perf:require('../../assets/perf.png'),
                hairdata:require('../../assets/hairdata.png'),
                hairjx:require('../../assets/hairjx.png'),
                staffjx:require('../../assets/staffjx.png'),
                hairstorereport:require('../../assets/hairstorereport.png'),
                ldmanager:require('../../assets/ldmanager.png'),
                douyin:require('../../assets/douyin.png'),
                work:require('../../assets/work.png'),
                workshow:false,
            }
        },
        created() {
          let storeid = localStorage.getItem("parentstoreid")
          if (storeid == "320c07ba76e94b0d8735aefe4470c07a" || storeid=="6862df117e404dffac984820fe15e320") {
            this.workshow = true;
          }
        },
        methods:{

        }
    }
</script>



// WEBPACK FOOTER //
// src/page/manager/hairgrid.vue